import { render, staticRenderFns } from "./XSCam.vue?vue&type=template&id=cef5bada&scoped=true&"
import script from "./XSCam.vue?vue&type=script&lang=ts&"
export * from "./XSCam.vue?vue&type=script&lang=ts&"
import style0 from "./XSCam.vue?vue&type=style&index=0&id=cef5bada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef5bada",
  null
  
)

export default component.exports